import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <SimpleTable>
    <div>
      <div>A Path:</div>
      <div>{node.extras.aPath}%</div>
    </div>
    <div>
      <div>B Path:</div>
      <div>{100 - node.extras.aPath}%</div>
    </div>
  </SimpleTable>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ABSplit/ABSplitDisplay.jsx